import { Flex, Separator } from 'components/base/layout-components';
import styled from 'styled-components';
import Icon from 'components/base/Icon';
import { getColor } from 'common/constants/_colors';

export const StyledReportedMetricsModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;

export const StyledIcon = styled(Icon)``;

export const StyledSelectorTitle = styled.div`
  font-size: 1.2rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
  &.disabled {
    color: gray;
  }
`;

export const StyledSeparator = styled(Separator)`
  display: horizontal;
  width: 100%;
  height: 1px;
  margin: 2rem 0;
`;

export const StyledHeader = styled(Flex)`
  margin-left: 1rem;
  font-size: 1.8rem;
  & ${StyledIcon} {
    padding-right: 1rem;
  }
`;

export const StyledInputWrapper = styled.div`
  margin-bottom: 1rem;
  & .MuiSelect-root {
    width: 32rem !important;
    height: 2.2rem;
  }

  & .MuiInputBase-root {
    width: 32rem !important;
  }
`;

export const StyledActionsContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin-top: 3rem;
`;

export const StyledDescription = styled.div`
  color: ${getColor('osloGray')};
  margin-bottom: 1rem;
`;
